<template>
    <option v-bind="$attrs" v-on="$listeners">
        <slot/>
    </option>
</template>
<script>
export default {
    name: 'Option',
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';

option {
    font-size: inherit;

    &:checked {
        background-color: rgba($blue, .1);
        color: $blue;
    }
}
</style>
